import { State } from "./state";
import { GetterTree } from "vuex";

import { getDataItem, getDataList, getError, getIsLoading, getSuccess, getTotal, getId } from "@/store/Crud/functions/getters";

export default <GetterTree<State, any>>{
  getError,
  getIsLoading,
  getDataItem,
  getSuccess,
  getDataList,
  getTotal,
  getId,
};
